import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login as authServiceLogin } from '../services/authService';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    
    setIsLoading(true);
    try {
      const token = await authServiceLogin(email, password);
      login(token);
      navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ 
      maxWidth: 400, 
      margin: '2rem auto', 
      padding: 'clamp(1rem, 4vw, 24px)', 
      background: '#fff', 
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      width: '90%'
    }}>
      <h2 style={{ 
        textAlign: 'center', 
        marginBottom: '1.5rem',
        fontSize: 'clamp(1.5rem, 5vw, 2rem)',
        color: 'hsl(var(--wealth-purple))'
      }}>Login</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <label style={{ 
            display: 'block', 
            marginBottom: '0.5rem', 
            fontWeight: '500',
            fontSize: 'clamp(0.9rem, 3vw, 1rem)'
          }}>Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            required 
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }} 
          />
        </div>
        <div>
          <label style={{ 
            display: 'block', 
            marginBottom: '0.5rem', 
            fontWeight: '500',
            fontSize: 'clamp(0.9rem, 3vw, 1rem)'
          }}>Password</label>
          <input 
            type="password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            required 
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }} 
          />
        </div>
        {error && <div style={{ 
          color: 'red', 
          marginBottom: '12px',
          fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
          textAlign: 'center'
        }}>{error}</div>}
        <button 
          type="submit" 
          disabled={isLoading}
          style={{ 
            width: '100%', 
            backgroundColor: isLoading ? '#ccc' : 'hsl(var(--wealth-purple))', 
            color: 'white', 
            border: 'none', 
            padding: 'clamp(0.75rem, 3vw, 12px)', 
            borderRadius: '4px', 
            cursor: isLoading ? 'not-allowed' : 'pointer',
            fontSize: 'clamp(0.9rem, 3vw, 16px)',
            fontWeight: '500',
            marginTop: '0.5rem',
            opacity: isLoading ? 0.7 : 1
          }}
        >
          {isLoading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '1rem',
        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)'
      }}>
        <Link 
          to="/forgot-password" 
          style={{ 
            color: 'hsl(var(--wealth-purple))',
            textDecoration: 'none',
            fontWeight: '500'
          }}
        >
          Forgot your password?
        </Link>
      </div>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '1.5rem',
        fontSize: 'clamp(0.9rem, 3vw, 1rem)'
      }}>
        Don't have an account?{' '}
        <Link 
          to="/register" 
          style={{ 
            color: 'hsl(var(--wealth-purple))',
            textDecoration: 'none',
            fontWeight: '500'
          }}
        >
          Create one
        </Link>
      </div>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '1rem',
        fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem'
      }}>
        <Link 
          to="/terms-of-service" 
          style={{ 
            color: '#666',
            textDecoration: 'none'
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate('/terms-of-service');
          }}
        >
          Terms of Service
        </Link>
        <span style={{ color: '#999' }}>•</span>
        <Link 
          to="/privacy-policy" 
          style={{ 
            color: '#666',
            textDecoration: 'none'
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate('/privacy-policy');
          }}
        >
          Privacy Policy
        </Link>
      </div>
      
      <div style={{ 
        textAlign: 'center', 
        marginTop: '0.5rem',
        fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)'
      }}>
        <Link 
          to="/account-deletion" 
          style={{ 
            color: '#666',
            textDecoration: 'none'
          }}
        >
          Delete Account
        </Link>
      </div>
    </div>
  );
};

export default LoginPage; 